<template>
  <div class="filter">
    <div class="innerItem filterInput">
      <p class="innerTitle toCapitalize f_medium" :placeholder="locale.search_placeholder">{{locale.search}}</p>
      <input type="text" class="input" :placeholder="locale.search_placeholder" v-model="filter.word">
    </div>
    <div class="innerItem filterCategory">
      <p class="innerTitle toCapitalize f_medium">{{locale.category}}</p>
      <select class="input toCapitalize" v-model="filter.type">
        <option value="">{{locale.all}}</option>
        <option
          v-for="type in types"
          :key="type"
          :value="type">{{localinfoType(type)}}</option>
      </select>
    </div>
    <div class="innerItem">
      <p class="innerTitle toCapitalize f_medium">{{locale.state}}</p>
      <div class="flexBox">
        <span class="checkbox flexInner">
          <input type="checkbox" id="view_show"
            v-model="listView.show"
            :disabled="listView.show && !listView.hide"
            @change="setListView" />
          <label for="view_show">{{locale.state_public}}</label>
        </span>
        <span class="checkbox flexInner">
          <input type="checkbox" id="view_hide"
            v-model="listView.hide"
            :disabled="!listView.show && listView.hide"
            @change="setListView" />
          <label for="view_hide">{{locale.state_private}}</label>
        </span>
      </div>
    </div>
    <div class="innerItem">
      <p class="innerTitle toCapitalize f_medium">{{locale.localinfo_registration_method}}</p>
      <div class="flexBox">
        <span class="checkbox flexInner">
          <input type="checkbox" id="view_provide"
            v-model="listView.provide"
            :disabled="listView.provide && !listView.create"
            @change="setListView" />
          <label for="view_provide">{{locale.localinfo_provided}}</label>
        </span>
        <span class="checkbox flexInner">
          <input type="checkbox" id="view_create"
            v-model="listView.create"
            :disabled="!listView.provide && listView.create"
            @change="setListView" />
          <label for="view_create">{{locale.localinfo_created}}</label>
        </span>
      </div>
    </div>
    <div class="innerItem">
      <p class="innerTitle toCapitalize f_medium">{{locale.recommend}}</p>
      <div class="flexBox">
        <span v-if="hasRecommend" class="checkbox flexInner">
          <input type="checkbox" id="view_recommended"
            v-model="listView.recommended"
            @change="setListView" />
          <label for="view_recommended">{{locale.localinfo_recommended}}</label>
        </span>
        <p v-else class="recommendMessage">{{locale.localinfo_recommend_message1}}<br><img src="~@/assets/img/ico_recommend.png" /> {{locale.localinfo_recommend_message2}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'locale'
  ],
  computed: {
    types () {
      return this.$store.getters['localinfo/getType']
    },
    filter: {
      get () {
        return this.$store.getters['localinfo/getFilter']
      },
      set (filter) {
        this.$store.commit('localinfo/setFilter', filter)
      }
    },
    hasRecommend () {
      return this.$store.getters['localinfo/getRecommend'].length > 0
    }
  },
  created () {
    this.init()
    this.$store.dispatch('localinfo/getLocalInfoType')
  },
  data () {
    return {
      /**
       * 리스트 보기 옵션
       * 공개: show
       * 비공개: hide
       * 기본제공: provide
       * 직접등록: create
       * 추천: recommended
       */
      listView: {
        show: true,
        hide: true,
        provide: true,
        create: true,
        recommended: false
      }
    }
  },
  methods: {
    init () {
      this.setListView()
      this.$store.commit('localinfo/initFilter')
    },
    localinfoType (type) {
      const localinfoType = `localinfo_${type}`
      return this.locale[localinfoType]
    },
    setListView () {
      this.$store.commit('localinfo/listView', this.listView)
    }
  }
}
</script>

<style lang="scss" scoped>
.flexBox {
  margin-left: 0;
  margin-right: 0;
  .flexInner {
    padding-left: 0;
    padding-right: 0;
  }
}
.filterCategory {
  .item {
    position: relative;
    margin-bottom: 15px;
    padding: 1.2em 1em 1.2em 30px;
    border: 1px solid $color-lgrey2;
    background-color: $color-white;
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: 10px;
      width: 10px;
      height: 10px;
      margin-top: -5px;
      opacity: 0.2;
    }
    &.active:before {
      opacity: 1;
    }
  }
  .checkbox {
    display: block;
  }
}
.recommendMessage {
  color: $color-grey;
  img {
    width: 20px;
    opacity: 0.7;
  }
}
</style>
